import { render, staticRenderFns } from "./LinkCard.vue?vue&type=template&id=a19f876c&scoped=true"
import script from "./LinkCard.vue?vue&type=script&lang=js"
export * from "./LinkCard.vue?vue&type=script&lang=js"
import style0 from "./LinkCard.vue?vue&type=style&index=0&id=a19f876c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a19f876c",
  null
  
)

export default component.exports